import React, { useState } from "react";
import { Avatar, Upload, message } from "antd";
import { uploadProfilePictureToAWSWithoutSaving } from "../../utils/pages";
import { UserOutlined, UploadOutlined } from "@ant-design/icons";

const WelcomeStep4 = ({
  setProfilePicture,
  profilePicture,
  setTheme,
  theme,
}) => {
  const [fileList, setFileList] = useState([]);

  const uploadImage = async (options) => {
    const { onSuccess, onError, file } = options;
    try {
      const fmData = new FormData();
      fmData.append("image", file);
      let picture = await uploadProfilePictureToAWSWithoutSaving(fmData);
      console.log(picture);
      if (picture) {
        setProfilePicture(picture.imageUrl);
        onSuccess("Ok");
      }
    } catch (err) {
      console.log("Error: ", err);
      new Error("Some error");
      onError({ err });
    }
  };

  const handleChange = async ({ file, fileList }) => {
    // setFileList(fileList);
    if (!file.status) {
      file.status = "error";
      setFileList([file]);
    } else {
      setFileList(fileList);
    }
    if (fileList.length === 0) {
      // setImageUrl();
    }
  };

  const handleBeforeUpload = (file) => {
    const isSmallerThan2Mb = file.size / 1024 / 1024 < 2;
    if (!isSmallerThan2Mb) {
      message.error("Votre image ne doit pas dépasser 2 Mo.");
      return false;
    } else {
      return true;
    }
  };

  const showUploadList = {
    showDownloadIcon: false,
    showRemoveIcon: false,
    showUploadList: true,
  };

  return (
    <div className="welcome-modal-content">
      <div className="header-modal">
        Une page à votre image{" "}
        <span role="img" aria-label="emoji">
          🎨
        </span>{" "}
      </div>
      <div className="content-welcome-modal">
        <p>Ajoutez votre photo de profil :</p>
        {/* handle PP upload */}
        <div className="input-pagename" style={{ marginBottom: "30px" }}>
          <Avatar
            size={70}
            style={{ marginTop: "20px" }}
            src={profilePicture ? profilePicture : ""}
            icon={<UserOutlined />}
          />
          <Upload
            fileList={fileList}
            customRequest={uploadImage}
            showUploadList={showUploadList}
            onChange={handleChange}
            beforeUpload={handleBeforeUpload}
            accept=".jpg,.png"
          >
            <div
              className="edit-picture"
              style={{ maxWidth: "100px", margin: "10px auto" }}
            >
              <div>
                <UploadOutlined />
              </div>
              {profilePicture ? "Modifier" : "Ajouter"}
            </div>
          </Upload>
          <div className="subtitle-edit-picture">(moins de 2 Mo) </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeStep4;
